import { atom, selector } from "recoil"

type TrulienceState = {
  micEnabled: boolean
  speakerEnabled: boolean
  avatarPhotoUrl?: string
  iframeHasLoaded: boolean
  iframeElement?: HTMLIFrameElement
  micPermissionState?: "granted" | "prompt" | "denied"
}

export const trulienceAtom = atom<TrulienceState>({
  key: "trulienceAtom",
  default: {
    micEnabled: true,
    speakerEnabled: true,
    iframeHasLoaded: false,
    iframeElement: null,
    micPermissionState: "denied"
  }
})

type TrulienceStateUpdate = Partial<TrulienceState>

export const TrulienceStateUpdater = selector<TrulienceStateUpdate>({
  key: "TrulienceStateUpdater",
  get: ({ get }) => get(trulienceAtom),
  set: ({ set }, newValue) => {
    set(trulienceAtom, (state) => ({
      ...state,
      ...newValue
    }))
  }
})

export const TrulienceStateCallbackSelector = selector({
  key: "TrulienceStateCallbackSelector",
  get: ({ getCallback }) => {
    const getTrulienceState = getCallback(({ snapshot }) => async () => {
      return snapshot.getPromise(trulienceAtom)
    })
    return { getTrulienceState }
  }
})
